import React from "react";

import classes from "./ExportLayoutSelect.module.css";
import { VIDEO_SOURCE_OPTIONS } from "./audioLayout.js";

const NO_ORIGINAL_HINT = "No original video stored for this project";

// Video picker shown next to a version name when exporting. Both options are
// always listed; only the original is disabled when the project has none.
const ExportVideoSourceSelect = ({
    id,
    value,
    onChange,
    hasSourceVideo,
    disabled = false,
    className = "",
}) => {
    const hintId = `${id}-hint`;

    return (
        <div className={`${classes["ExportLayout"]} ${className}`}>
            <label className={classes["ExportLayoutLabel"]} htmlFor={id}>
                Video
            </label>
            <select
                id={id}
                className={classes["ExportLayoutSelect"]}
                value={value}
                disabled={disabled}
                aria-describedby={hasSourceVideo ? undefined : hintId}
                onChange={(event) => onChange(event.target.value)}
            >
                {VIDEO_SOURCE_OPTIONS.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                        disabled={option.value === "original" && !hasSourceVideo}
                    >
                        {option.label}
                    </option>
                ))}
            </select>
            {!hasSourceVideo && (
                <p id={hintId} className={classes["ExportLayoutHint"]}>
                    {NO_ORIGINAL_HINT}
                </p>
            )}
        </div>
    );
};

export default ExportVideoSourceSelect;
